import Button from "/components/common/button";
import styles from "../popupFormWrapper/index.module.scss";
import React from "react";
import { useRouter } from "next/router";

export default function CartEmpty() {
  const router = useRouter();

  return (
    <>
      <h2>Корзина пуста</h2>
      <div className={styles.Content}>
        <p>Добавьте товары в корзину, чтобы оформить заказ.</p>
        <Button
          label="Перейти в каталог"
          onClick={() => {
            router.push("/catalog/");
          }}
        />
      </div>
    </>
  );
}
